import { RHFCode } from './RhfCode';
import { RHFRating } from './RhfRating';
import { RHFSlider } from './RhfSlider';
import { RHFTextField } from './RhfTextField';
import { RHFRadioGroup } from './RhfRadioGroup';
import { RHFPhoneInput } from './RhfPhoneInput';
import { RHFEditor } from './RhfEditor';
import { RHFNumberInput } from './RhfNumberInput';
import { RHFAutocomplete } from './RhfAutocomplete';
import { RHFCountrySelect } from './RhfCountrySelect';
import { RHFSwitch, RHFMultiSwitch } from './RhfSwitch';
import { RHFSelect, RHFMultiSelect } from './RhfSelect';
import { RHFCheckbox, RHFMultiCheckbox } from './RhfCheckbox';
import { RHFUpload, RHFUploadBox, RHFUploadAvatar } from './RhfUpload';
import { RHFDatePicker, RHFMobileDateTimePicker } from './RhfDatePicker';

// ----------------------------------------------------------------------

export const Field = {
  Code: RHFCode,
  Editor: RHFEditor,
  Select: RHFSelect,
  Upload: RHFUpload,
  Switch: RHFSwitch,
  Slider: RHFSlider,
  Rating: RHFRating,
  Text: RHFTextField,
  Phone: RHFPhoneInput,
  Checkbox: RHFCheckbox,
  UploadBox: RHFUploadBox,
  RadioGroup: RHFRadioGroup,
  DatePicker: RHFDatePicker,
  NumberInput: RHFNumberInput,
  MultiSelect: RHFMultiSelect,
  MultiSwitch: RHFMultiSwitch,
  UploadAvatar: RHFUploadAvatar,
  Autocomplete: RHFAutocomplete,
  MultiCheckbox: RHFMultiCheckbox,
  CountrySelect: RHFCountrySelect,
  MobileDateTimePicker: RHFMobileDateTimePicker,
};
